import { NavLink } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

import {
  toolCategories,
  type AppLocale,
  type ToolDefinition,
} from '../app/config';

type SidebarProps = {
  currentLocale: AppLocale;
  isOpen: boolean;
  tools: ToolDefinition[];
  onClose: () => void;
};

export function Sidebar({
  currentLocale,
  isOpen,
  tools,
  onClose,
}: SidebarProps) {
  const { t } = useTranslation();

  return (
    <aside className={`sidebar${isOpen ? ' open' : ''}`}>
      <div className='sidebar-header'>
        <div className='sidebar-logo'>
          <img src='/img/dracula-tools.gif' alt='Dracula Tools' />
          <span>{t('seo.siteTitle')}</span>
        </div>
        <button
          className='mobile-menu-close'
          onClick={onClose}
          type='button'
          aria-label={t('common.closeMenu')}
        >
          <i className='fas fa-times' aria-hidden='true' />
        </button>
      </div>

      {toolCategories.map(category => {
        const categoryTools = tools.filter(
          tool => tool.category === category.id
        );
        if (categoryTools.length === 0) {
          return null;
        }

        return (
          <div className='tool-categories' key={category.id}>
            <h3 className='category-title'>
              {t(`navigation.categories.${category.translationKey}`)}
            </h3>
            <ul className='tools-nav'>
              {categoryTools.map(tool => (
                <li className='tool-nav-item' key={tool.id}>
                  <NavLink
                    to={`/${currentLocale}/${tool.id}`}
                    className={({ isActive }) =>
                      `tool-nav-link${isActive ? ' active' : ''}`
                    }
                    onClick={onClose}
                  >
                    <i
                      className={`${tool.icon} tool-icon`}
                      aria-hidden='true'
                    />
                    {t(`navigation.tools.${tool.translationKey}.name`)}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        );
      })}

      {tools.length === 0 ? (
        <p className='search-empty'>{t('common.noSearchResults')}</p>
      ) : null}
    </aside>
  );
}
